export const fileSubmissionStatus = ['uploaded', 'sent'] as const;

export type FileSubmissionStatus = (typeof fileSubmissionStatus)[number];
